import React from "react";

import { Container } from "./styles";

function Background() {
  return <Container />;
}

export default Background;
